import type {
  FetchNextPageOptions,
  InfiniteQueryObserverResult,
} from '@tanstack/react-query'

import { T } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons'

interface Props {
  fetchNextPage?: (
    options?: FetchNextPageOptions,
  ) => Promise<InfiniteQueryObserverResult>
  hasNextPage?: boolean
  isFetchingNextPage?: boolean
}
export const ShowMoreButton = ({
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
}: Props) => {
  if (!hasNextPage) {
    return null
  }

  return (
    <Button
      variant="outline"
      onClick={() => fetchNextPage()}
      className="flex-shrink-0"
      trailingIcon={
        isFetchingNextPage ? (
          <SpinnerIcon className="h-5 w-5 animate-spin" />
        ) : null
      }
      fullWidth
    >
      <T defaultMessage="Show more" id="Generics.ShowMore" />
    </Button>
  )
}
